const userNameValid = /[^#&<>"~;,!$^%{}?^0-9]$/;

export const validLastName = (lastName: string): string => {
	const lastNames = lastName?.trim()?.split(" ");

	if (!lastName?.length) {
		return "A vezetéknév megadása kötelező!";
	}

	if (lastNames.find((name) => name.length < 2)) {
		return "A vezetéknévnek legalább 2 karakterből kell állnia!";
	}

	if (lastNames.find((name) => name.length > 32)) {
		return "A vezetéknév legfeljebb 32 karakterből állhat!";
	}

	if (lastNames.find((name) => !userNameValid.test(name))) {
		return "Érvénytelen karakter a névben!";
	}
};

export const validFirstName = (givenName: string): string => {
	const firstName = givenName?.trim();

	if (!firstName?.length) {
		return "A keresztnévnek megadása kötelező!";
	}

	if (firstName.length < 3) {
		return "A keresztnévnek legalább 3 karakterből kell állnia!";
	}

	if (firstName.length > 32) {
		return "A keresztnévnek legfeljebb 32 karakterből állhat!";
	}

	if (!userNameValid.test(firstName)) {
		return "Érvénytelen karakter a névben!";
	}
};
